import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Button, Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatDateTime, getConfigByKey, getSupplierOrderStatus } from 'helpers/format'
import { SupplierOrderDetailReq, UpdateSupplierOrderStatusReq } from 'Store/supplier-order/types'
import { getSupplierOrderDetailAPI, updateSupplierOrderStatusAPI } from 'Store/supplier-order/api'
import {
  selectSupplierOrderActionEvent,
  selectSupplierOrderDetail,
  selectSupplierOrderDetailEvent,
} from 'Store/supplier-order/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/supplier-order/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ProductsTable from './components/ProductsTable'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { ConfirmDailog } from 'Components/modal'
import { DocumentConfigKey, DocumentDefaultTitle, SupplierOrderStatus } from 'helpers/constanst'
import { selectProductsGrnList } from 'Store/stock/selector'
// import QuotationSummay from './components/QuotationSummay'
import { AppTextArea } from 'Components/form'
import SupplierOrderInfo from './components/SupplierOrderInfo'
import ClientInfo from './components/ClientInfo'
import DeliveryInfo from './components/DeliveryInfo'
import ReturnDrawer from './components/ReturnDrawer'
import { getStaffPermission } from 'helpers/account'
import ReturnOrderDrawer from 'Pages/OrderReturns/components/ReturnOrderDrawer'
import { RedoOutlined } from '@ant-design/icons'
import SaleOrderPDFDetail from './components/SaleOrderPDFDetail'
import QuotationSummay from 'Pages/Quotation/components/QuotationSummay'
import { selectConfigList } from 'Store/pos/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const QuotationDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    detail,
    detailEvent,
    configList,
  } = props

  const dispatch = useDispatch()
  const [statusUpdating, setStatusUpdating] = useState('' as SupplierOrderStatus)
  const [showReturnDrawer, setShowReturnDrawer] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [saleOrderPDFtitle, setSaleOrderPDFtitle] = useState(DocumentDefaultTitle.SALEORDER as string)
  const [reason, setReason] = useState('')
  const saleOrderPDF = useRef(null as any)
  const saleOrderLitePDF = useRef(null as any)
  const permission = getStaffPermission()
  const hasReturnPermission = permission && permission.includes('create-order-returns')
  const [showReturnHistoryDrawer, setShowReturnHistoryDrawer] = useState(false)
  const hasReturnProduct = detail?.products?.find(item => item?.return_qty > 0)
  const configDataQu = getConfigByKey(configList, DocumentConfigKey.QUOTATION)
  const configShowVat =
    configDataQu && configDataQu?.config_value && JSON.parse(configDataQu?.config_value || '')
  const showVat = configShowVat?.enableTax || false

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible])

  const onGetDetail = (): void => {
    const req: SupplierOrderDetailReq = {
      id,
    }
    dispatch(getSupplierOrderDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdateStatus = (status: SupplierOrderStatus): void => {
    const req: UpdateSupplierOrderStatusReq = {
      id,
      status: status,
      reason: reason,
    }
    dispatch(
      updateSupplierOrderStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
  }

  const onClickUpdateStatus = (status: SupplierOrderStatus): void => {
    setStatusUpdating(status)
    setConfirmDialog(true)
  }

  const onClickReturn = (): void => {
    setShowReturnDrawer(true)
  }

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title="ยืนยันการเปลี่ยนสถานะคำสั่งซื้อ"
      description={`คุณแน่ใจที่จะเปลี่ยนสถานะเป็น "${getSupplierOrderStatus(statusUpdating).text}" หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={() => onUpdateStatus(statusUpdating)}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const renderFooterContent = () => {
    const btn = [] as any[]
    if (detail?.status === SupplierOrderStatus.PREPARE) {
      btn.push(
        <PrimaryButton
          btnType="Primary"
          text="ดำเนินการจัดส่ง"
          onClick={() => {
            onClickUpdateStatus(SupplierOrderStatus.ON_DELIVERY)
          }}
        />,
      )
    }

    if (detail?.status === SupplierOrderStatus.ON_DELIVERY) {
      btn.push(
        <PrimaryButton
          btnType="Primary"
          text="จัดส่งสำเร็จ"
          onClick={() => {
            onClickUpdateStatus(SupplierOrderStatus.DELIVERED)
          }}
        />,
      )
    }

    if (detail?.status === SupplierOrderStatus.DELIVERED && hasReturnPermission) {
      btn.push(
        <PrimaryButton
          key={`${detail?.status}-return`}
          text="สร้างรายการรับคืนสินค้า"
          btnType="Reject"
          onClick={() => onClickReturn()}
          //disabled={!hasProduct}
        />,
      )
    }

    return (
      <Space size="middle" align="baseline">
        <PrimaryButton btnType="Cancel" text="ปิด" onClick={onCloseDrawer} />
        {btn}
      </Space>
    )
  }

  const renderTitle = () => {
    return (
      <Row justify="space-between" gutter={[8, 8]} align="top">
        <Col>
          <Space direction="vertical" size="small">
            <Space size="small" wrap={true}>
              {`เลขที่สั่งซื้อ : ${detail?.sale_order_no}`}
            </Space>
            <Space size="small" wrap={true}>
              <SmallText>วันที่สั่งซื้อ : {formatDateTime(detail?.created_at || '')}</SmallText>
            </Space>
          </Space>
        </Col>
        <Col>
          {detail?.status === SupplierOrderStatus.DELIVERED && (
            <Button type="text" onClick={() => setShowReturnHistoryDrawer(true)} danger>
              <RedoOutlined /> ประวัติการรับคืนสินค้า
            </Button>
          )}
        </Col>
      </Row>
    )
  }

  const ReturnDrawerContent = (
    <ReturnDrawer
      visible={showReturnDrawer}
      onClose={() => setShowReturnDrawer(false)}
      detail={detail}
      onSuccess={() => {
        setShowReturnDrawer(false)
        onGetDetail()
      }}
    />
  )

  const ReturnHistory = (
    <ReturnOrderDrawer
      isShow={showReturnHistoryDrawer}
      onClose={() => setShowReturnHistoryDrawer(false)}
      orderNo={detail?.sale_order_no}
      onSuccess={() => onGetDetail()}
    />
  )

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={renderFooterContent()}
      width={'90%'}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      {ConfirmApproveDailog}
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          <SupplierOrderInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <ClientInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <DeliveryInfo detail={detail} />
        </Col>

        <Col md={24} xs={24}>
          <ProductsTable
            products={detail?.products || []}
            viewMode={true}
            saleOrderPdfRef={saleOrderPDF}
            saleOrderLitePdfRef={saleOrderLitePDF}
            quotation_no={detail?.quotation_no}
            detail={detail}
            onSelectTitle={setSaleOrderPDFtitle}
          />
        </Col>
        <Col md={12} xs={24}></Col>
        <Col md={8} xs={24}>
          <SummaryInfo>
            <QuotationSummay detail={detail} showVat={showVat} />
          </SummaryInfo>
        </Col>
      </Row>
      <SaleOrderPDFDetail
        orderDetail={detail}
        saleOrderLitePDF={saleOrderLitePDF}
        saleOrderPDF={saleOrderPDF}
        title={saleOrderPDFtitle}
      />
      {detail?.status === SupplierOrderStatus.PREPARE && (
        <Row>
          <Col md={24} xs={24}>
            <AppTextArea
              label="หมายเหตุ (ถ้ามี)"
              placeHolder="ระบุหมายเหตุ"
              isRequired={false}
              isError={false}
              name="reason"
              rows={2}
              value={reason}
              onChange={(val: string) => setReason(val)}
            />
          </Col>
        </Row>
      )}
      {ReturnDrawerContent}
      {detail?.status === SupplierOrderStatus.DELIVERED && ReturnHistory}
    </DetailDrawer>
  )
}

const SummaryInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
`

const SmallText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectSupplierOrderActionEvent(state),
    detail: selectSupplierOrderDetail(state),
    detailEvent: selectSupplierOrderDetailEvent(state),
    supplierList: selectAllSupplierList(state),
    productsGrn: selectProductsGrnList(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QuotationDetail)
